import Axios from "axios";

const url_api = process.env.VUE_APP_API_URL;

export function getAll() {
  return Axios.get(url_api + "/api/usage");
}

//
export function get(type, id) {
  return Axios.get(url_api + "/api/usage/" + type + "/" + id);
}

// Guarda los datos
/* export function post(type, data) {
  return Axios.post(url_api + "/api/usage/" + type, data);
}
 */
export function post(data) {
  return Axios.post(url_api + "/api/usage", data);
}

export function group(data) {
  return Axios.post(url_api + "/api/usage/group", data);
}

// Actualiza uno o varios datos
export function put(type, data) {
  return Axios.put(url_api + "/api/usage/" + type, data);
}
